// Import Types
import type { FormulaFilterListItem, FormulaFilterDetail, FormulaColumn } from 'types/formulaFilter';
// Import Services
import { generateCleanUrlParams } from 'services/Helpers';
import { CRMRequestService, getCancelableRequest, postCancelableRequest } from './http.config';

const CustomFormulaHttpService = {
    getList: () => {
        return getCancelableRequest<FormulaFilterListItem[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/CustomFormula/List',
        });
    },
    get: () => {
        return getCancelableRequest<FormulaFilterDetail>({
            requestService: CRMRequestService,
            defaultParams: { isClone: false },
            endpointPath: ({ id, isClone, pointInTime }) =>
                `/CustomFormula/Get${generateCleanUrlParams({ id, isClone, pointInTime })}`,
        });
    },
    create: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/CustomFormula/Create`,
        });
    },
    update: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/CustomFormula/Update`,
        });
    },
    getColumns: () => {
        return getCancelableRequest<FormulaColumn[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/CustomFormula/GetColumns',
        });
    },
    delete: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ id }) => `/CustomFormula/Delete?id=${id}`,
        });
    },
    archive: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ id }) => `/CustomFormula/Archive?id=${id}`,
        });
    },
    unarchive: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ id }) => `/CustomFormula/Unarchive?id=${id}`,
        });
    },
    preview: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/CustomFormula/Preview',
        });
    },
};

export default CustomFormulaHttpService;
